import React from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { handleGetCatalogAreaRequest } from "store/modules/Catalog/thunk.store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import CardProductCovered from "components/CardProductCovered";
import { useParams } from "react-router-dom";
import * as Styled from "./styles";
import { Checkbox } from "@mui/material";
import { grey } from "@mui/material/colors";
import { CoverageAreaProps } from "store/modules/Logistics/types.store";
import { toast } from "utils/toast";

const AccordionProductCovered = ({
  product,
  dealerSelected,
  handleOpenArea,
  isMassEdit,
  handleMassEditData,
  massEditData,
  gasDoPovo,
}: any) => {
  const dispatch = useAppDispatch();
  const { dealerId = "" } = useParams<{ dealerId: string }>();

  const { coverageArea } = useAppSelector((state) => state.catalog);

  const [expand, setExpand] = React.useState(false);

  const handleGetArea = async () => {
    if (!expand) {
      await dispatch(
        handleGetCatalogAreaRequest({
          coverageAreaId: product.id,
          userId: dealerId,
        }),
      ).unwrap();
      setExpand(true);
    }
    setExpand(!expand);
  };

  const verifyCheckbox = () => {
    return (
      massEditData?.length > 0 &&
      massEditData?.some((item: CoverageAreaProps) => item.id === product.id)
    );
  };

  const handleChangeCheckbox = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!product.enabled) {
      toast.error(
        "Mapa desabilitado, para selecioná-lo ative-o e tente novamente!",
      );
      return;
    }
    handleMassEditData({
      ...product,
    });
  };

  return (
    <div>
      <Accordion expanded={expand}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={() => handleGetArea()}
        >
          <Styled.ContainerTitle>
            {isMassEdit && (
              <Checkbox
                checked={verifyCheckbox()}
                onClick={handleChangeCheckbox}
                color={product?.enabled ? "primary" : "warning"}
                sx={
                  product?.enabled
                    ? undefined
                    : {
                        color: grey[300],
                        "&.Mui-checked": {
                          color: grey[300],
                        },
                      }
                }
              />
            )}
            <Typography
              color={product?.enabled ? "text.primary" : "text.disabled"}
            >
              {product?.name}
            </Typography>
          </Styled.ContainerTitle>
        </AccordionSummary>
        <AccordionDetails style={{ padding: 0 }}>
          <CardProductCovered
            handleOpenArea={handleOpenArea}
            dealerSelected={dealerSelected}
            accordion
            coverageArea={
              coverageArea?.find(
                (area) => area.coverageAreaId === dealerSelected,
              ) as any
            }
            gasDoPovo={gasDoPovo}
            workingAreaType={product?.type}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default AccordionProductCovered;
